
export const HomePageMenu = [
    {
        label: 'timetable',
        href: '/timetable',
        isMobile: false,
        submenu: [
            {
                label: 'Fall_schedule_2021',
                href: '/fall-schedule',
            },
            {
                label: 'Lesson_descriptions',
                href: '/lesson-descriptions',
            },
            {
                label: 'Teachers',
                href: '/teacher',
            },
            {
                label: 'Price_List',
                href: '/price-list',
            },
            {
                label: 'Beginner_classes',
                href: '/beginner-lessons',
            },
            {
                label: 'Solo_classes',
                href: '/solo-classes',
            },
            {
                label: 'Kids_classes',
                href: '/kids-classes',
            },
            {
                label: 'Couple_dancing',
                href: '/couple-dancing',
            },
            {
                label: 'Practising_studio',
                href: '/practising-in-studio',
            },
            {
                label: 'Customized_lesson',
                href: '/customized-group-lesson',
            },
        ],
    },
    {
        label: 'registration',
        href: '/registration',
        isMobile: false,
    },
    {
        label: 'online_store',
        href: '/online-shop',
        isMobile: false,
    },
    {
        label: 'whats_on',
        href: '/whats-on',
        isMobile: false,
    },
    {
        label: 'HSDS@HOME',
        href: '/hsds-home',
        isMobile: false,
    },
    {
        label: 'more',
        href: '/more',
        isMobile: false,
        submenu: [
            {
                label: 'HSDS_blog',
                href: '/blogs',
            },
            {
                label: 'Studio_rental',
                href: '/studio-rental',
            },
            {
                label: 'Customized_lessons',
                href: '/customized-lessons',
                submenu: [
                    {
                        label: 'Business_hours',
                        href: '/business-hours',
                    },
                    {
                        label: 'Bachelorette Parties &\n Anniversaries',
                        href: '/Bachelorette',
                    },

                    {
                        label: 'WEDDING DANCES',
                        href: '/wedding-dances',
                    },
                ],
            },
            {
                label: 'services',
                href: '/osteopathy-physiotherapy-massage',
            },
            {
                label: 'Frequently_asked',
                href: '/frequently-asked',
            },
            {
                label: 'Privacy_Statement',
                href: '/privacy-statement',
            },
        ],
    },
    {
        label: 'login/signup',
        href: '/login',
        isMobile: true,
        isAuthenticated: false,
    },
    //  {
    //   label: 'wishlist',
    //   href: '/wishlist',
    //   isMobile: false,
    //   isAuthenticated: true,
    //  },
    {
        label: 'dashboard',
        href: '/my/dashboard',
        isMobile: true,
        isAuthenticated: true,
    },
    {
        label: 'cart',
        href: '/cart',
        isMobile: true,
        isAuthenticated: true,
    },
    {
        label: 'logOut',
        href: '/',
        isMobile: true,
        isAuthenticated: true,
    },
];
export const HomePageMenuTeacher = [

    {
        label: 'registration',
        href: '/registration',
        isMobile: false,
    },
    {
        label: 'HallRental',
        href: '/hall_rental',
        isMobile: false,
        isAuthenticated: true,
    },
    {
        label: 'MyClasses',
        href: '/myclasses',
        isMobile: false,
        isAuthenticated: true,
    },
    {
        label: 'login/signup',
        href: '/login',
        isMobile: true,
        isAuthenticated: false,
    },
    //  {
    //   label: 'wishlist',
    //   href: '/wishlist',
    //   isMobile: false,
    //   isAuthenticated: true,
    //  },
    {
        label: 'dashboard',
        href: '/my/dashboard',
        isMobile: true,
        isAuthenticated: true,
    },
    {
        label: 'cart',
        href: '/cart',
        isMobile: true,
        isAuthenticated: true,
    },
    {
        label: 'logOut',
        href: '/',
        isMobile: true,
        isAuthenticated: true,
    },
];

export const TeachereMenu = [
    // {
    //     label: 'My_Classes',
    //     href: '/classes',
    //     isMobile: false,
    //     isAuthenticated: true,
    // },
    {
        label: 'HallRental',
        href: '/hall_rental',
        isMobile: false,
        isAuthenticated: true,
    },
    {
        label: 'MyClasses',
        href: '/myclasses',
        isMobile: false,
        isAuthenticated: true,
    },
    {
        label: 'logout',
        href: '/',
        isMobile: true,
        isAuthenticated: true,
    },
];

export const AdminPageMenu = [
    {
        label: 'cash',
        href: '/cash',
        isMobile: false,
        isAuthenticated: true,
        submenu: [
            {
                label: 'sales',
                href: '/cashier',
            },
            {
                label: 'receipts',
                href: '/allsales',
            },
        ],
    },
    {
        label: 'orders',
        href: '/orders',
        isMobile: false,
        isAuthenticated: true,
    },
    {
        label: 'appointment',
        href: '/appointments',
        isMobile: false,
        isAuthenticated: true,
    },
    {
        label: 'Products',
        href: '#',
        isMobile: false,
        isAuthenticated: true,
        submenu: [
            {
                label: 'Products',
                href: '/products',
            },
            {
                label: 'Product_Category',
                href: '/product-category',
            },
            // {
            //     label: 'Product_Brand',
            //     href: '/products/brand',
            // },

            {
                label: 'stock',
                href: '/stock',
            },
            {
                label: 'campaign',
                href: '/campaigns',
            },
        ],
    },
    {
        label: 'Customer',
        href: '/customers',
        isMobile: false,
        isAuthenticated: true,
        submenu: [
            {
                label: 'Customer',
                href: '/customer',
            },
            {
                label: 'Customer_Groups',
                href: '/customer/customergroups',
            },
            {
                label: 'Customer_Messages',
                href: '/customer/messages/dashboard',
            },
        ],
    },
    {
        label: 'Teachers',
        href: '/teacher',
        isMobile: false,
        isAuthenticated: true,
        submenu: [
            {
                label: 'Teachers',
                href: '/teachers',
            },
        ],
    },
    {
        label: 'billing',
        href: '/billing',
        isMobile: false,
        isAuthenticated: true,
        submenu: [],
    },
    {
        label: 'reportage',
        href: '/sales-report',
        isMobile: false,
        isAuthenticated: true,
    },
    {
        label: 'blogs',
        href: '/blogList',
        isMobile: false,
        isAuthenticated: true,
    },
    {
        label: 'cms',
        href: '/cms',
        isMobile: false,
        isAuthenticated: true,
    },
    {
        label: 'logout',
        href: '/',
        isMobile: true,
        isAuthenticated: true,
    },
];

export const customerSubMenu = [
    {
        label: 'customer_data',
        id: 1,
    },
    {
        label: 'account',
        id: 2,
    },
    {
        label: 'customer_groups',
        id: 3,
    },
    {
        label: 'purchase_history',
        id: 4,
    },
    {
        label: 'booking_history',
        id: 5,
    },
    {
        label: 'customer_reports',
        id: 6,
    },
];

export const productAddSubMenu = [
    {
        label: 'product_info',
        id: 1,
    },
    {
        label: 'price_info',
        id: 2,
    },
    {
        label: 'product_groups',
        id: 3,
    },
    {
        label: 'product_images',
        id: 4,
    },
    {
        label: 'attachements',
        id: 5,
    },
    {
        label: 'sales_history',
        id: 6,
    },
    {
        label: 'sales_order_history',
        id: 7,
    },
];


export const BannerText: any = {
    shallWe_fi: 'VOISIMMEKO',
    shallWe_en: 'SHALL WE',
    dance_en: 'DANCE',
    dance_fi: 'TANSSI',
    celebrate_en: 'CELEBRATE YOUR LIFE WITH US',
    celebrate_fi: 'Juhli elämääsi kanssamme',
    learn_en: 'Learn More',
    learn_fi: 'Lisätietoja',
};
export const BannerLearnMorePopup = {
    title: 'DONEC LOBORTIS PHARETRA DOLOR',
    content:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, rds which don't look even slightly believable..",
};
export const HSDS_Center = {
    lat: 60.16,
    lng: 24.9,
};
export const email = 'hsds2@aol.com';

export const address = {
    name: 'Haapalainen SuutariJääskö Dance Studios',
    place: 'Kaapelitehdas',
    addressLine1: 'Tallberginkatu 1 C 4th floor',
    postalCode: '00180',
    city: 'Helsinki',
};

export const mobile = {
    number: '0504651006',
    help_text_key: 'mobile_text',
};

export const socialLinks = {
    facebook:
        'https://www.google.com/url?sa=t&rct=j&q=&esrc=s&source=web&cd=7&cad=rja&uact=8&ved=2ahUKEwiPnJTAr-nkAhW8Q0EAHYVoCcYQFjAGegQIAhAB&url=https%3A%2F%2Fd.facebook.com%2FHaapalainensuutarijaaskodancestudio%2F&usg=AOvVaw0ZYmPEM-8I9xM74dVU_ist',
    instagram: 'https://www.instagram.com/haapalainensuutaridancestudios/',
};

export const addressFields = [
    {
        id: 'fulladdress',
        labelId: 'street_address',
        fieldType: 'textArea',
        lines: 2,
        placeHolderId: 'addressLine1',
        rules: [{ required: true, message: 'error.addressLine1' }],
    },
    {
        id: 'addressLine2',
        labelId: 'addressLine2',
        fieldType: 'input',
        placeHolderId: 'addressLine2',
        rules: [],
    },
    {
        id: 'city',
        labelId: 'city',
        fieldType: 'input',
        placeHolderId: 'city',
        rules: [{ required: true, message: 'error.city' }],
    },
    {
        id: 'country',
        labelId: 'country',
        fieldType: 'input',
        placeHolderId: 'country',
        rules: [{ required: true, message: 'error.country' }],
    },
    {
        id: 'postalCode',
        labelId: 'postalCode',
        fieldType: 'input',
        placeHolderId: 'postalCode',
        rules: [
            { required: true, message: 'error.postalCode' },
            {
                pattern: new RegExp(/\d+/g),
                message: 'error.invalid_pin_code',
            },
        ],
    },
];

export const phoneField = [
    {
        id: 'mobile',
        labelId: 'mobile',
        fieldType: 'inputNumber',
        placeHolderId: 'mobile',
        rules: [
            {
                type: 'number',
                message: 'error.invalid_mobile_number',
            },
        ],
    },
    {
        id: 'type',
        labelId: 'type',
        fieldType: 'input',
        placeHolderId: 'type',
        rules: [],
    },
];

export const emailField = [
    {
        id: 'email',
        labelId: 'email',
        fieldType: 'input',
        placeHolderId: 'email',
        rules: [
            { required: true, message: 'error.email' },
            { type: 'email', message: 'error.invalid_email' },
        ],
    },
    {
        id: 'type',
        labelId: 'type',
        fieldType: 'input',
        placeHolderId: 'type',
        rules: [],
    },
];

export const cmsMenu = [
    {
        label: 'Home_Banner_Images',
        id: 1,
        value: 'HBI',
        isEditable: false,
        isDeletable: false,
        canAddChildren: false,
    },
    {
        label: 'Gallery_Images',
        id: 2,
        value: 'galleryimage',
        isEditable: false,
        isDeletable: false,
        canAddChildren: false,
    },
    {
        label: 'about_us',
        id: 3,
        value: 'about_us',
        isEditable: false,
        isDeletable: false,
        canAddChildren: false,
    },
    {
        label: 'Registration',
        id: 32,
        value: 'Regist',
        isEditable: false,
        isDeletable: false,
        canAddChildren: false,
    },
    {
        label: 'Classes',
        id: 10,
        value: 'classes',
        isEditable: false,
        isDeletable: false,
        canAddChildren: false,
    },
    {
        label: 'Schedule',
        id: 4,
        value: 'schedule',
        isEditable: false,
        isDeletable: false,
        canAddChildren: false,
    },
    {
        label: 'Hallcapacity',
        id: 21,
        value: 'capacity',
        isEditable: false,
        isDeletable: false,
        canAddChildren: false,
    },
    {
        label: 'Practicing_studio',
        id: 13,
        value: 'practising_studio',
        isEditable: false,
        isDeletable: false,
        canAddChildren: false,
    },
    {
        label: 'Customized_Group_Lessons',
        id: 8,
        value: 'customized_lessons',
        isEditable: false,
        isDeletable: false,
        canAddChildren: false,
    },
    {
        label: 'Whats_On',
        id: 5,
        value: 'current_affairs',
        isEditable: false,
        isDeletable: false,
        canAddChildren: false,
    },
    {
        label: 'HSDS_Home',
        id: 6,
        value: 'hsds_home',
        isEditable: false,
        isDeletable: false,
        canAddChildren: false,
    },
    {
        label: 'Studio_Rental',
        id: 7,
        value: 'studio_rental',
        isEditable: false,
        isDeletable: false,
        canAddChildren: false,
    },
    {
        label: 'Customized_Lessons',
        id: 10,
        value: 'Order',
        isEditable: false,
        isDeletable: false,
        canAddChildren: false,
        submenu: [
            {
                label: 'Business_Hours',
                id: 1,
                value: 'Business',
                isEditable: false,
                isDeletable: false,
                canAddChildren: false,
            },
            {
                label: 'Bachelorate_parties_and_dances',
                id: 2,
                value: 'Bachelorette',
                isEditable: false,
                isDeletable: false,
                canAddChildren: false,
            },
            {
                label: 'Wedding_dances',
                id: 3,
                value: 'wedding_dances',
                isEditable: false,
                isDeletable: false,
                canAddChildren: false,
            },
        ],
    },
    {
        label: 'Other_Services',
        id: 9,
        value: 'other_services',
        isEditable: false,
        isDeletable: false,
        canAddChildren: false,
    },

    {
        label: 'Frequently_Asked',
        id: 11,
        value: 'faq',
        isEditable: false,
        isDeletable: false,
        canAddChildren: false,
    },
    {
        label: 'Privacy_Statement',
        id: 12,
        value: 'privacy',
        isEditable: false,
        isDeletable: false,
        canAddChildren: false,
    },
    {
        label: 'Terms_Conditions',
        id: 14,
        value: 'Terms_And_Condition',
        isEditable: false,
        isDeletable: false,
        canAddChildren: false,
    },
    {
        label: 'Cookies_Policy',
        id: 15,
        value: 'Cookies_policy',
        isEditable: false,
        isDeletable: false,
        canAddChildren: false,
    },
    {
        label: 'Refunds_Cancellations',
        id: 13,
        value: 'cancellation',
        isEditable: false,
        isDeletable: false,
        canAddChildren: false,
    },

    // {
    //     label: 'Footer',
    //     id: 14,
    //     value: 'footer',
    //     isEditable: false,
    //     isDeletable: false,
    //     canAddChildren: false,
    // },
];

export const languages = [
    { value: 'English', key: 'en' },
    { value: 'Finnish', key: 'fi' },
];
export const productList = [
    {
        id: 1,
        image: 'https://images-na.ssl-images-amazon.com/images/I/91bgABXpaaS._UX679_.jpg',
        name: 'Säärystimet nilkka pituus 40cm',
        description: 'TP1351',
        original_price: 1400,
        discount_price: 1200,
        currency: '$',
    },
    {
        id: 2,
        image: 'https://images-na.ssl-images-amazon.com/images/I/91bgABXpaaS._UX679_.jpg',
        name: 'Säärystimet nilkka pituus 40cm',
        description: 'TP1351',
        original_price: 1400,
        discount_price: 1200,
        currency: '$',
    },
    {
        id: 3,
        image: 'https://images-na.ssl-images-amazon.com/images/I/91bgABXpaaS._UX679_.jpg',
        name: 'Säärystimet nilkka pituus 40cm',
        description: 'TP1351',
        original_price: 1400,
        discount_price: 1200,
        currency: '$',
    },
    {
        id: 4,
        image: 'https://images-na.ssl-images-amazon.com/images/I/91bgABXpaaS._UX679_.jpg',
        name: 'Säärystimet nilkka pituus 40cm',
        description: 'TP1351',
        original_price: 1400,
        discount_price: 1200,
        currency: '$',
    },
    {
        id: 5,
        image: 'https://images-na.ssl-images-amazon.com/images/I/91bgABXpaaS._UX679_.jpg',
        name: 'Säärystimet nilkka pituus 40cm',
        description: 'TP1351',
        original_price: 1400,
        discount_price: 1200,
        currency: '$',
    },
    {
        id: 6,
        image: 'https://images-na.ssl-images-amazon.com/images/I/91bgABXpaaS._UX679_.jpg',
        name: 'Säärystimet nilkka pituus 40cm',
        description: 'TP1351',
        original_price: 1400,
        discount_price: 1200,
        currency: '$',
    },
    {
        id: 7,
        image: 'https://images-na.ssl-images-amazon.com/images/I/91bgABXpaaS._UX679_.jpg',
        name: 'Säärystimet nilkka pituus 40cm',
        description: 'TP1351',
        original_price: 1400,
        discount_price: 1200,
        currency: '$',
    },
    {
        id: 8,
        image: 'https://images-na.ssl-images-amazon.com/images/I/91bgABXpaaS._UX679_.jpg',
        name: 'Säärystimet nilkka pituus 40cm',
        description: 'TP1351',
        original_price: 1400,
        discount_price: 1200,
        currency: '$',
    },
    {
        id: 9,
        image: 'https://images-na.ssl-images-amazon.com/images/I/91bgABXpaaS._UX679_.jpg',
        name: 'Säärystimet nilkka pituus 40cm',
        description: 'TP1351',
        original_price: 1400,
        discount_price: 1200,
        currency: '$',
    },
];

export const reviewSection = [
    {
        id: 1,
        image: 'http://localhost:3000/static/media/teacher6.3fca695d.jpeg',
        name: 'John Doe',
        description: 'john doe',
        reviewText:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged',
        date: 'June 02,2021',
    },
    {
        id: 2,
        image: 'http://localhost:3000/static/media/teacher6.3fca695d.jpeg',
        name: 'John Doe',
        description: 'john doe',
        reviewText:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged',
        date: 'June 02,2021',
    },
    {
        id: 3,
        image: 'http://localhost:3000/static/media/teacher6.3fca695d.jpeg',
        name: 'John Doe',
        description: 'john doe',
        reviewText:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged',
        date: 'June 02,2021',
    },
    {
        id: 4,
        image: 'http://localhost:3000/static/media/teacher6.3fca695d.jpeg',
        name: 'John Doe',
        description: 'john doe',
        reviewText:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged',
        date: 'June 02,2021',
    },
    {
        id: 5,
        image: 'http://localhost:3000/static/media/teacher6.3fca695d.jpeg',
        name: 'John Doe',
        description: 'john doe',
        reviewText:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged',
        date: 'June 02,2021',
    },
    {
        id: 6,
        image: 'https://images-na.ssl-images-amazon.com/images/I/91bgABXpaaS._UX679_.jpg',
        name: 'John Doe',
        description: 'john doe',
        reviewText:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged',
        date: 'June 02,2021',
    },
];

export const passesList = [
    {
        title: 'One Time Fee 60Min',
        price: '€17',
        button: 'Buy Now',
    },
    {
        title: '5 Times Card ',
        price: '€17',
        button: 'Buy Now',
        validity: '2 months ',
    },
    {
        title: 'One Time Fee 60Min',
        price: '€17',
        button: 'Buy Now',
    },
    {
        title: '5 Times Card ',
        price: '€17',
        button: 'Buy Now',
        validity: '2 months ',
    },
    {
        title: 'One Time Fee 60Min',
        price: '€17',
        button: 'Buy Now',
    },
    {
        title: '5 Times Card ',
        price: '€17',
        button: 'Buy Now',
        validity: '2 months ',
    },
];
export const giftCardsList = [
    {
        title: 'HSDS',
        price: '€50',
    },
    {
        title: 'HSDS',
        price: '€100',
    },
    {
        title: 'HSDS',
        price: '€150',
    },
    {
        title: 'HSDS',
        price: '€200',
    },
    {
        title: 'HSDS',
        price: '€250',
    },
    {
        title: 'HSDS',
        price: '€300',
    },
];
export const categoryList = [
    {
        image:
            'https://images.unsplash.com/photo-1587563871167-1ee9c731aefb?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTl8fHNob2V8ZW58MHx8MHx8&ixlib=rb-1.2.1&w=1000&q=80',
        name: 'Category 1',
    },
    {
        image:
            'https://images.unsplash.com/photo-1587563871167-1ee9c731aefb?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTl8fHNob2V8ZW58MHx8MHx8&ixlib=rb-1.2.1&w=1000&q=80',
        name: 'Category 2',
    },
    {
        image:
            'https://images.unsplash.com/photo-1587563871167-1ee9c731aefb?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTl8fHNob2V8ZW58MHx8MHx8&ixlib=rb-1.2.1&w=1000&q=80',
        name: 'Category 3',
    },
    {
        image:
            'https://images.unsplash.com/photo-1587563871167-1ee9c731aefb?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTl8fHNob2V8ZW58MHx8MHx8&ixlib=rb-1.2.1&w=1000&q=80',
        name: 'Category 4',
    },
    {
        image:
            'https://images.unsplash.com/photo-1587563871167-1ee9c731aefb?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTl8fHNob2V8ZW58MHx8MHx8&ixlib=rb-1.2.1&w=1000&q=80',
        name: 'Category 5',
    },
    {
        image:
            'https://images.unsplash.com/photo-1587563871167-1ee9c731aefb?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTl8fHNob2V8ZW58MHx8MHx8&ixlib=rb-1.2.1&w=1000&q=80',
        name: 'Category 6',
    },
];

export const Languages = [
    { key: 'en', label: 'ENG', fullLabel: 'ENGLISH' },
    { key: 'fi', label: 'FIN', fullLabel: 'FINNISH' },
];

export const TenderStatus = [
    {
        value: 'all',
        label: "All",
    },
    {
        value: 'no_status',
        label: "No Status",
    },
    {
        value: 'dont_tender',
        label: "Don't Tender",
    },
    {
        value: 'potential',
        label: "Potential",
    },
    {
        value: 'proposed_for_tendering',
        label: "Proposed for tendering",
    },
    {
        value: 'tendering_postponed',
        label: "Tendering postponed",
    },
    {
        value: 'tendering_rejected',
        label: "Tendering rejected",
    },
    {
        value: 'approved_for_tendering',
        label: "Approved for tendering",
    },
    {
        value: 'tendering_ongoing',
        label: "Tendering ongoing",
    },
    {
        value: 'tendering_deadline_closing_soon',
        label: "Tendering deadline closing soon",
    },
    {
        value: 'check_loan_comparison',
        label: "Check loan comparison",
    },
    {
        value: 'comparison_sent',
        label: "comparison sent",
    },
    {
        value: 'signed_meeting_minutes_received',
        label: "Signed meeting minutes received",
    },
    {
        value: 'waiting_for_decision',
        label: "Waiting for decision",
    },
    {
        value: 'end_tender',
        label: "Tendering closed",
    },
    {
        value: 'waiting_for_signed_bond',
        label: "Waiting for signed bond",
    },
    {
        value: 'bond_sent_to_accounting',
        label: "Bond sent to accounting",
    },
    {
        value: 'invoiced',
        label: "Invoiced",
    },
    {
        value: 'done',
        label: "Done",
    },
    {
        value: 'tendering_declined',
        label: "Tendering declined",
    },
    {
        value: 'requested_for_tendering',
        label: "Requested for tendering",
    }
];

export const TenderEditStatus = [
 
 
    {
        value: 'dont_tender',
        label: "Don't Tender",
    },
    {
        value: 'potential',
        label: "Potential",
    },
    {
        value: 'proposed_for_tendering',
        label: "Proposed for tendering",
    },
    {
        value: 'tendering_postponed',
        label: "Tendering postponed",
    },
    {
        value: 'tendering_rejected',
        label: "Tendering rejected",
    },
    {
        value: 'approved_for_tendering',
        label: "Approved for tendering",
    },
    {
        value: 'tendering_ongoing',
        label: "Tendering ongoing",
    },
    {
        value: 'tendering_deadline_closing_soon',
        label: "Tendering deadline closing soon",
    },
    {
        value: 'check_loan_comparison',
        label: "Check loan comparison",
    },
    {
        value: 'comparison_sent',
        label: "comparison sent",
    },
    {
        value: 'signed_meeting_minutes_received',
        label: "Signed meeting minutes received",
    },
    {
        value: 'waiting_for_decision',
        label: "Waiting for decision",
    },
    {
        value: 'end_tender',
        label: "Tendering closed",
    },
    {
        value: 'waiting_for_signed_bond',
        label: "Waiting for signed bond",
    },
    {
        value: 'bond_sent_to_accounting',
        label: "Bond sent to accounting",
    },
    {
        value: 'invoiced',
        label: "Invoiced",
    },
    {
        value: 'done',
        label: "Done",
    },
    {
        value: 'tendering_declined',
        label: "Tendering declined",
    },
    {
        value: 'requested_for_tendering',
        label: "Requested for tendering",
    }
];

export const PaymentMethodOptions = [
    { value: "tasalyhennys", label: "Tasalyhennys" },
    { value: "annuiteetti", label: "Annuiteetti" },
    { value: "tasaerä", label: "Tasaerä" }
];

export const ReferenceRateBaseOptions = [
    { value: "3kk Euribor", label: "3kk Euribor" },
    { value: "6kk Euribor", label: "6kk Euribor" },
    { value: "12kk Euribor", label: "12kk Euribor" }
];

export const monthOptions = [
    {value:1,label:'January'},
    {value:2,label:'February'},
    {value:3,label:'March'},
    {value:4,label:'April'},
    {value:5,label:'May'},
    {value:6,label:'June'},
    {value:7,label:'July'},
    {value:8,label:'August'},
    {value:9,label:'September'},
    {value:10,label:'October​'},
    {value:11,label:'November'},
    {value:12,label:'December'},
];

export const CloudFileBasePath = "https://loantendering.blob.core.windows.net/retta-lot/";

export const LogStatus = [{value:'1',label:'Active'},{value:'0',label:'In-active'}]